export class AuthViewGlossary {
    public static readonly DARK_THEME = "Тёмная тема";
    public static readonly LIGHT_THEME = "Светлая тема";

    public static readonly LIGHT_THEME_LOGO_SRC = "./images/logo/logo.png";
    public static readonly DARK_THEME_LOGO_SRC = "./images/logo/logo_dark.png";
}